import { render, staticRenderFns } from "./protocolPopup.vue?vue&type=template&id=1749b6c1&scoped=true&"
import script from "./protocolPopup.vue?vue&type=script&lang=js&"
export * from "./protocolPopup.vue?vue&type=script&lang=js&"
import style0 from "./protocolPopup.vue?vue&type=style&index=0&id=1749b6c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749b6c1",
  null
  
)

export default component.exports